/**
 * Campaign status enum matching backend CampaignStatus — canonical 3-value model
 * (OP-6198). Status is derived from action statuses; the manual-cancel state was removed.
 * Draft → Active (an Email action has been sent) → Completed (terminal/read-only).
 */
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["Draft"] = "Draft";
    CampaignStatus["Active"] = "Active";
    CampaignStatus["Completed"] = "Completed";
})(CampaignStatus || (CampaignStatus = {}));
/**
 * Terminal campaign statuses that block all further edits (OP-6198). The backend rejects edits in
 * these states with HTTP 409 `CAMPAIGN_NOT_EDITABLE` (Campaign.EnsureEditable); the FE read-only
 * gate is the UX layer mirroring that capability (R42). Shared by the detail and editor stores.
 */
export const FINISHED_CAMPAIGN_STATUSES = [
    CampaignStatus.Completed,
];
/**
 * Communication action status enum matching backend CommunicationActionStatus.
 */
export var CommunicationActionStatus;
(function (CommunicationActionStatus) {
    CommunicationActionStatus["Draft"] = "Draft";
    CommunicationActionStatus["ReadyToSend"] = "ReadyToSend";
    CommunicationActionStatus["Scheduled"] = "Scheduled";
    CommunicationActionStatus["Dispatching"] = "Dispatching";
    CommunicationActionStatus["Queued"] = "Queued";
    CommunicationActionStatus["Sent"] = "Sent";
    CommunicationActionStatus["Failed"] = "Failed";
})(CommunicationActionStatus || (CommunicationActionStatus = {}));
/**
 * Statuses that are not yet settled — the action is mid-delivery and the backend will move it
 * to a terminal status (Sent / Failed) on its own. The timeline auto-polls while any action sits
 * in one of these and surfaces a per-row manual refresh affordance, so the user sees the status
 * settle without reloading the whole page. Sent / Failed are terminal; Draft / ReadyToSend /
 * Scheduled are user-driven (no backend transition pending).
 */
export const TRANSIENT_ACTION_STATUSES = [
    CommunicationActionStatus.Queued,
    CommunicationActionStatus.Dispatching,
];
/** True when the action is mid-delivery (see {@link TRANSIENT_ACTION_STATUSES}). */
export function isTransientActionStatus(status) {
    return TRANSIENT_ACTION_STATUSES.includes(status);
}
